import { render } from "./FleetEmission.vue?vue&type=template&id=327f17d6&scoped=true"
import script from "./FleetEmission.vue?vue&type=script&lang=js"
export * from "./FleetEmission.vue?vue&type=script&lang=js"

import "./FleetEmission.vue?vue&type=style&index=0&id=327f17d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327f17d6"]])

export default __exports__